import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import Headline from '../../../../components/library/headline';
import Button from '../../../../components/library/button';
import sSafecheckValidatedSuccess from './safeCheckValidatedSuccess.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

export const enhance = compose(
  withStyles(sSafecheckValidatedSuccess),
  withRouter,
);

function SafecheckValidatedSuccess(props) {
  return (
    <>
      <div className={sSafecheckValidatedSuccess['safecheck-success-modal']}>
        <div
          className={
            sSafecheckValidatedSuccess['edit-detail-success-modal-content']
          }
        >
          <Headline tag="h1" as="h1" centered italic>
            Success!
          </Headline>
        </div>
        <div className={sSafecheckValidatedSuccess['success-modal-content']}>
          <Headline tag="h2" as="h3" centered>
            You are now enrolled in SafeCheck. Check your enrolled phone to view
            your confirmation text message. This may take a few minutes.
          </Headline>
        </div>
        <div className={sSafecheckValidatedSuccess['success-modal-content']}>
          <Headline tag="h3" as="h4" centered>
            If you do not see a text, please re-enter and update your number.
          </Headline>
        </div>

        <div className={sSafecheckValidatedSuccess['button-row']}>
          <div className={sSafecheckValidatedSuccess['button-content']}>
            <Button
              display="primary"
              kind="solid"
              size="medium"
              onClick={() => {
                props.onClose(false);
              }}
            >
              View SafeCheck
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

SafecheckValidatedSuccess.PropTypes = {
  onClose: PropTypes.func,
};

export default enhance(SafecheckValidatedSuccess);
